<!-- src/layouts/publicLayout.vue -->
<template>
  <main class="page">
    <router-view />
  </main>
</template>

<script setup></script>

<style scoped></style>
